import React, { Component, Fragment } from 'react';

import MenuTable from './MenuTable';
import MenuModal from './MenuModal';

const blankMenu = {
  _id: undefined,
  title: undefined,
  user: undefined,
  createdAt: undefined,
  items: [],
  position: undefined,
};

class Menu extends Component {
  state = {
    showMenuEditor: false,
    menu: null,
    menuEditorType: undefined,
  }

  handleShowMenuEditor = (menu) => {
    console.log(menu, 'xxx');
    let item;
    let info;
    let type;
    if (menu) {
      item = 'Sửa danh mục';
      type = 'edit';
      info = { ...menu };
    } else {
      item = 'Tạo danh mục';
      type = 'create';
      info = null;
    }
    // this.props.handleChangeBreadCrumb('push', item);
    this.setState({
      showMenuEditor: true,
      menu: info,
      menuEditorType: type,
    });
  }

  closeMenuEditor = () => {
    // this.props.handleChangeBreadCrumb('pop');
    this.setState({
      showMenuEditor: false,
      menu: null,
      menuEditorType: undefined,
    });
  }

  render() {
    const { showMenuEditor, menu, menuEditorType } = this.state;
    return (
      <Fragment>
        <MenuTable
          showMenuEditor={this.handleShowMenuEditor}
          formItemLayout={this.props.formItemLayout}
          tailFormItemLayout={this.props.tailFormItemLayout}
        />
        <MenuModal
          visible={showMenuEditor}
          onCancel={() => this.setState({
            showMenuEditor: false,
            menu: null,
            menuEditorType: undefined,
          })}
          initialValue={menu}
        />
      </Fragment>
    );
    // return showMenuEditor ?
    //   <MenuEditor
    //     menu={menu}
    //     type={menuEditorType}
    //     closeMenuEditor={this.closeMenuEditor}
    //     formItemLayout={this.props.formItemLayout}
    //     tailFormItemLayout={this.props.tailFormItemLayout}
    //   /> :
    //   <MenuTable
    //     showMenuEditor={this.showMenuEditor}
    //     formItemLayout={this.props.formItemLayout}
    //     tailFormItemLayout={this.props.tailFormItemLayout}
    //   />;
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Menu/Menu.js